
function findCurrentPage(pagesData, currentPageId) {
    for (let i = 0; i < pagesData.length; i++) {
        let currPage = pagesData[i];
        if (currPage.id === currentPageId) {
            return currPage;
        }
        if (currPage.childPages) {
            currPage = findCurrentPage(currPage.childPages, currentPageId);
            if (currPage && currPage.id === currentPageId) {
                return currPage;
            }
        }
    }
}

function removeCompIdFromPagesData(pagesData) {
    pagesData.forEach((pageData) => {
        delete pageData.id;
        if (pageData.childPages) {
            removeCompIdFromPagesData(pageData.childPages);
        }
    });
}
//
// function isDynamicPage(routers, pageId) {
//     return some(routers, (routerData) => {
//         return includes(values(routerData.pages), pageId);
//     });
// }

function isDynamicPage(pageSiteStructureData) {
    return pageSiteStructureData.prefix;
}

function getPageURI(currentPageSiteStructureData, currentNavigationInfo) {
    if (isDynamicPage(currentPageSiteStructureData)) {
        return `/${currentNavigationInfo.routerDefinition.prefix}/${currentNavigationInfo.innerRoute}`;
    }
    if (currentPageSiteStructureData) {
        return currentPageSiteStructureData.url;
    }
}

export {
    findCurrentPage,
    removeCompIdFromPagesData,
    isDynamicPage,
    getPageURI
};
